export default __webpack_public_path__ + "static/arrow-0454c1488b0d7cfbae83c8cdae217b76.svg";